<div (click)="productDetails(element)">
  <div class="product-card" [class.product-card-mobile]="isMobile">

    @if(calcDis(element.priceb,element.pricec) !== 0){
    <div class="discount-badge">
      {{ calcDis(element.priceb,element.pricec) }}%
      {{ "discount" | transloco }}
    </div>
    }

    @if(element.is_daily_offer){
    <div class="daily-offer-badge">
      <span class="offer-label">
        {{ "saveuptotext" | transloco }}
      </span>
      <div class="chip-timer" [class.alert-error-text]="(dailyOfferState.progress$ | async)! <= 80">
        {{ dailyOfferState.timer$ | async }}
      </div>
    </div>
    }

    <div class="product-visual">
      <div class="product-circle"></div>
      <div class="product-circle-dots"></div>

      @if(element.image != null){
      <div class="product-img" [class.product-img-mobile]="isMobile">
        <img [defaultImage]="'/assets/imageloading.gif'" [lazyLoad]="bybrand ? element.image : fixImage(element.image)"
          [errorImage]="'/assets/noproduct.png'" alt="product" />
      </div>
      } @else {
      <div class="product-img" [class.product-img-mobile]="isMobile">
        @if(element.pet == '0'){
        <img src="/assets/noproduct cat.webp" alt="product">
        } @else {
        <img src="/assets/noproduct dog.png" alt="product">
        }
      </div>
      }
    </div>

    <div class="product-info">
      @if(isAr){
      <p class="product-name" [class.product-name-mobile]="isMobile">
        {{ element.name_ar }}
      </p>
      } @else {
      <p class="product-name" [class.product-name-mobile]="isMobile">
        {{ element.name_en }}
      </p>
      }

      <div class="price-row">
        <span class="new-price" [class.new-price-mobile]="isMobile">
          {{ element.is_daily_offer ? element.affiliationprice : element.pricec }}
          {{ "egpe" | transloco }}
        </span>

        @if(calcDis(element.is_daily_offer ? element.affiliationprice : element.pricec, element.priced) != 0){
        <span class="old-price">
          {{ element.priced }} {{ "egpe" | transloco }}
        </span>
        }
      </div>

      <button class="btn btn-add"
        [class.alert-error]="element.is_daily_offer && (dailyOfferState.progress$ | async)! <= 80"
        (click)="addToCart(element, element.quantity); $event.stopPropagation()">
        {{ "addtocart" | transloco }}
      </button>
    </div>

  </div>
</div>
